import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function FinalCTA() {
  const { t } = useLanguage();
  return (
    <section data-testid="final-cta" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a14] via-ink to-[#050510]" />
      <div
        className="absolute inset-0 opacity-40"
        style={{ backgroundImage: "radial-gradient(ellipse at 50% 50%, rgba(255,215,0,0.18), transparent 60%)" }}
      />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white leading-[0.95] break-words"
        >
          {t.finalCta.headingLine1}
          <br />
          {t.finalCta.headingLine2Start} <span className="text-gold">{t.finalCta.headingLine2End}</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-8 text-white/70 text-lg max-w-2xl mx-auto"
        >
          {t.finalCta.sub}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a
            href="#quote"
            data-testid="final-cta-btn"
            className="group inline-flex items-center justify-center gap-2 bg-gold text-ink font-bold uppercase tracking-widest px-10 py-4 rounded hover:bg-gold-hover transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_30px_rgba(255,215,0,0.5)]"
          >
            {t.finalCta.btnPrimary}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="tel:7865438906"
            className="inline-flex items-center justify-center border-2 border-white/60 text-white font-bold uppercase tracking-widest px-10 py-4 rounded hover:bg-white hover:text-ink transition-all duration-300"
          >
            {t.finalCta.btnSecondary}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
